export const categories = [
  { id: "saas", name: "SaaS" },
  { id: "ecommerce", name: "E-commerce" },
  { id: "crm", name: "CRM" },
  { id: "project-management", name: "Project Management" },
  { id: "analytics", name: "Analytics" },
  { id: "social", name: "Social" },
  { id: "marketplace", name: "Marketplace" },
  { id: "education", name: "Education" },
  { id: "healthcare", name: "Healthcare" },
  { id: "finance", name: "Finance" },
  { id: "real-estate", name: "Real Estate" },
  { id: "fitness", name: "Fitness" },
  { id: "travel", name: "Travel" },
  { id: "restaurant", name: "Restaurant" },
  { id: "portfolio", name: "Portfolio" },
];

export const useCases = [
  { id: "project-management", name: "Project Management" },
  { id: "marketing", name: "Marketing" },
  { id: "sales", name: "Sales & CRM" },
  { id: "hr", name: "HR & Recruiting" },
  { id: "finance", name: "Finance & Accounting" },
  { id: "operations", name: "Operations" },
  { id: "support", name: "Customer Support" },
  { id: "design", name: "Design & UX" },
  { id: "development", name: "Development" },
  { id: "content", name: "Content Management" },
  { id: "ecommerce", name: "E-commerce" },
  { id: "education", name: "Education" },
  { id: "healthcare", name: "Healthcare" },
  { id: "real-estate", name: "Real Estate" },
  { id: "events", name: "Events" },
];

export const templates = [
  {
    id: "template-1",
    stackId: "react-node",
    name: "SaaS Starter",
    description:
      "SaaS starter with auth, dashboard, and Stripe billing scaffold — configure keys and DB before live payments",
    category: "saas",
    useCases: ["project-management", "development"],
    features: [
      "User Authentication",
      "Subscription Billing",
      "Admin Dashboard",
      "User Management",
      "Analytics",
      "Email Notifications",
    ],
    techStack: [
      "React",
      "TypeScript",
      "Express",
      "PostgreSQL",
      "Stripe",
      "Tailwind",
    ],
  },
  {
    id: "template-2",
    stackId: "react-node",
    name: "E-commerce Store",
    description:
      "Full-featured online store with product catalog, cart, and payments",
    category: "ecommerce",
    useCases: ["ecommerce", "sales"],
    features: [
      "Product Catalog",
      "Shopping Cart",
      "Payment Processing",
      "Order Management",
      "Inventory Tracking",
      "Customer Accounts",
    ],
    techStack: [
      "React",
      "TypeScript",
      "Express",
      "PostgreSQL",
      "Stripe",
      "Tailwind",
    ],
  },
  {
    id: "template-3",
    stackId: "react-node",
    name: "CRM System",
    description:
      "Customer relationship management with pipeline tracking and analytics",
    category: "crm",
    useCases: ["sales", "marketing"],
    features: [
      "Contact Management",
      "Sales Pipeline",
      "Task Management",
      "Email Integration",
      "Reports & Analytics",
      "Team Collaboration",
    ],
    techStack: ["React", "TypeScript", "Express", "PostgreSQL", "Tailwind"],
  },
  {
    id: "template-4",
    stackId: "react-node",
    name: "Project Management",
    description:
      "Task and project tracking with boards, timelines, and team collaboration",
    category: "project-management",
    useCases: ["project-management", "operations"],
    features: [
      "Task Boards",
      "Gantt Charts",
      "Time Tracking",
      "Team Collaboration",
      "File Sharing",
      "Progress Reports",
    ],
    techStack: ["React", "TypeScript", "Express", "PostgreSQL", "Tailwind"],
  },
  {
    id: "template-5",
    stackId: "data-visualization",
    name: "Analytics Dashboard",
    description:
      "Data visualization and analytics with charts, metrics, and reports",
    category: "analytics",
    useCases: ["finance", "marketing", "operations"],
    features: [
      "Data Visualization",
      "Custom Dashboards",
      "Real-time Metrics",
      "Report Generation",
      "Data Export",
      "API Integration",
    ],
    techStack: [
      "React",
      "TypeScript",
      "Express",
      "PostgreSQL",
      "Chart.js",
      "Tailwind",
    ],
  },
  {
    id: "template-6",
    stackId: "react-node",
    name: "Social Network",
    description:
      "Social platform with feeds, profiles, messaging, and notifications",
    category: "social",
    useCases: ["social", "content"],
    features: [
      "User Profiles",
      "Activity Feed",
      "Messaging",
      "Notifications",
      "Content Sharing",
      "Follow System",
    ],
    techStack: [
      "React",
      "TypeScript",
      "Express",
      "PostgreSQL",
      "Socket.io",
      "Tailwind",
    ],
  },
];

export type Template = (typeof templates)[number];

export default { categories, useCases, templates };
